import * as Sentry from '@sentry/react';
import type { RootOptions } from 'react-dom/client';

// React 19 reports render errors through createRoot callbacks instead of rethrowing them.
// onCaughtError is left out: Sentry.ErrorBoundary already reports what it catches, and other
// boundaries handle their errors on purpose (ErrorBoundarySuspense reloads on chunk-load errors).
export const sentryRootErrorHandlers: Pick<RootOptions, 'onUncaughtError' | 'onRecoverableError'> =
  {
    onUncaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
  };
